export const homeownerTheme = {
  background: "bg-gradient-to-br from-[#f8f6f3] via-[#faf8f6] to-[#f5f1ed]",
  primary: "bg-black hover:bg-slate-700 text-white",
  primaryOutline: "border-slate-300 hover:bg-slate-50 text-slate-700",
  accent: "text-slate-900",
  cardBg: "bg-white/80",
  badge: "bg-slate-50 text-slate-700 border-slate-200",
};

export const providerTheme = {
  background: "bg-gradient-to-br from-[#f3f6f8] via-[#f6f8fa] to-[#edf2f5]",
  primary: "bg-blue-600 hover:bg-blue-700 text-white",
  primaryOutline: "border-blue-300 hover:bg-blue-50 text-blue-700",
  accent: "text-blue-600",
  cardBg: "bg-white/90",
  badge: "bg-blue-50 text-blue-700 border-blue-200",
  // Better gradient options for left side
  //   heroGradient: "bg-gradient-to-br from-blue-800 via-slate-800 to-slate-900", // Blue-grey mix
  heroGradient: "bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800", // Subtle blue
};

export const adminTheme = {
  background: "bg-slate-50",
  primary: "bg-slate-900 hover:bg-slate-800 text-white",
  primaryOutline: "border-slate-300 hover:bg-slate-100 text-slate-700",
  accent: "text-slate-900",
  cardBg: "bg-white",
  badge: "bg-slate-100 text-slate-700 border-slate-200",
  navBg: "bg-slate-900",
  navText: "text-slate-300",
  navTextActive: "text-white",
};

export const isProviderApp = () => {
  const hostname = window.location.hostname;

  return hostname.startsWith("pro.");
};

export const isAdminApp = () => {
  const hostname = window.location.hostname;

  return hostname.startsWith("admin.");
};

export const getTheme = () => {
  if (isAdminApp()) return adminTheme;
  return isProviderApp() ? providerTheme : homeownerTheme;
};

export const getOppositeAppUrl = () => {
  return isProviderApp()
    ? process.env.REACT_APP_HOMEOWNER_APP_URL
    : process.env.REACT_APP_PROVIDER_APP_URL;
};
